export let CREATE_DUPLICATE_TASK = '/admin/task/duplicate';
export let DELETE_TASK = '/admin/task/delete';
export const NOTIFICATION_EVENTS = "/admin/app/notification-events";
export const NOTIFICATION_TEMPLATES = "/admin/app/notification-templates";
export const NOTIFICATION_EVENT_SETTINGS =
  "admin/notification-events/settings/";
//Dashboard
export const DEFAULT_INFO = "default-info";
export const COMPANY_REPORTS = "/admin/company-reports";
export const COMPANY_REPORTS_SUBMIT = "/admin/company-reports/store";
export const SUBMIT_COMPANY_REPORT = "/admin/company-reports";
export const COMPANY_REPORTS_DETAIL = "/admin/company/reports/detail/list";
export const COMPANY_REPORT_DOWNLOAD = "/admin/company/report/download";
export const DEFAULT_ACADEMIC_INFO = "default-academic-info";
export const DEFAULT_DASHBOARD_INFO = "default-dashboard-info";
export const AVAILABLE_COURSE_LIST = "available-course-list";
export const STUDENT_OVERVIEW = "student-overview";
export const SCHOOL_OVERVIEW = "school-overview";
export const INSTRUCTOR_STUDENT_OVERVIEW = "instructor-student-overview";
export const AUDIENCE_OVERVIEW_CHART = "audience-overview-chart";
export const BROWSER_OVERVIEW_CHART = "browser-overview-chart";
export const BUSINESS_OVERVIEW = "business-overview";
export const CONTACT_OVERVIEW = "contact-overview";
export const TEAM_OVERVIEW = "team-overview";
export const DOCTORS_LIST = "doctors-list";
export const UPCOMING_APPOINTMENTS = "upcoming-appointments";
export const DEFAULT_HOSPITAL_INFO = "default-hospital-info";
export const HOSPITAL_ACTIVITIES = "hospital-activities";
export const PATIENT_STATISTICS = "patient-statistics";
export const HRM_BASIC_DATA = "hrm-basic-data";
export const PROJECT_OVERVIEW = "project-overview";
export const YEARLY_HOLIDAY = "yearly-holiday";
export const EMPLOYEE_OVERVIEW = "employee-overview";

//Sample pages
export const REPORTS = "reports";
export const CALENDARS = "calendars";
export const STAGES = "stages";
export const TASKS = "tasks";

//Profile
export const MY_PROFILE = "/my-profile";
export const All_NOTIFICATION = "/all-notifications";
export const NOTIFICATION_TASK_DETAIL_VIEW = "/admin/notification/task/view";
export const LOGOUT = "/admin/log-out";

//app setting view
export const APP_SETTINGS = "/app-setting";
export const GENERAL_SETTINGS = "general-settings";

//reCAPTCHA
export const GET_RECAPTCHA_SETTINGS = "/get-re-captcha-setting";
//Sms settings
export const GET_SMS_SETTINGS_INFO = "get-sms-setting-info";
//Email settings
export const GET_EMAIL_SETTINGS = "/admin/app/settings/delivery-settings";
export const UPDATE_EMAIL_BANNER = "admin/setting/email/banner";
export const UPDATE_BANKING_DETAIL = "admin/setting/banking/detail";

//DataTable
export const DATATABLE_DATA = "crud";
export const DATATABLE_SEARCH_SELECT = "/datatable/name";

//roles and users
export const ROLES = "admin/auth/roles";
export const USERS = "admin/auth/users";
export const STORE_USER = "admin/auth/users";
export const USERS_LIST = "user-list";
export const ALL_USERS = "all-users";
export const GET_USERS = "get/users";
export const GET_STATUSES = "admin/app/statuses";
export const INVITE_USER = "/admin/auth/users/invite-user";
export const DETACH_ROLES = "admin/auth/users/detach-roles/";
export const UPDATE_USER_NAME = "/update-user-name/";
export const USER_VERIFIED = "/admin/user/verified";

//Notification
export const NOTIFICATIONS = "/admin/user/notifications";
export const NOTIFICATIONS_TYPE = "/admin/user/notifications/types";
export const AUTHENTICATE_USER = "/admin/authenticate-user";
export const LOGIN_USER = "/login-user";

// Language
export const LANGUAGE = "languages";
export const BASIC_SETTINGS = "/get-basic-setting-data";

// Social links
export const CHANGE_SOCIAL_LINKS = "/change-social-link";

//Payment Methods
export const PAYMENT_METHOD = "/payment-method";
export const GET_PAYMENT_METHOD_STATUS = "/payment-method-status";
export const GET_STRIPE_STATUS = "/stripe-status";
export const GET_PAYPAL_STATUS = "/paypal-status";

export const PAYMENT_METHODS_list = '/admin/payment/methods/list';

export const GET_COMPANY_USERS = "/admin/users";
export const GET_COMPANY_JOBS = "/admin/jobs";

export const GET_TASK_CATEGORIES = "/admin/task-categories";
export const TASK_CATEGORY_LISTING = "/admin/task/category/listing";
export const TASK_CATEGORY_STORE = "/admin/task/category/store";
export const TASK_CATEGORY_SHOW = "/admin/task/category/show";
export const TASK_CATEGORY_UPDATE = "/admin/task/category/update";
export const TASK_CATEGORY_DISTROY = "/admin/task/category/distroy";
export const GET_PENDDING_TASKS = "/admin/task/pandding";
export const DEPENDENT_TASK = "/admin/task/dependent";
export const TASK_REMINDER = '/admin/task/reminder';


export const GET_ATTACH_DOCUMENT = '/admin/task/attach/document/get';
export const GET_USER_ATTACH_DOCUMENT = '/admin/task/attach/user/documents';
export const TASK_ATTACH_DOCUMENT = '/admin/task/attach/document';
export const GET_ATTACH_DOCUMENT_USER = "/admin/task/attach/document/user";
export const GET_USER_DOCUMENT = "/admin/task/user/document/";
export const TASK_ATTACH_DOCUMENT_DELETE = '/admin/task/attach/document/delete';

export const GUEST_FORM = '/guest-response/form';
export const GUEST_USER_INFO = '/guest-response/user';
export const TASK_ASSIGN_FORMS = '/admin/task/assign/form';
export const ASSIGN_PUBLIC_FORM = '/task/assign-public-form';
export const RESPONSE_DATE_UPDATE = '/response/update-date';
export const RESPONSE_DELETE = '/response/delete';

export const TASK_ASSIGN_FORM_SHOW = '/admin/task/assign/form/show';
export const JOB_REVIEW_FORM_SHOW = '/admin/job/review/form/show';

export const TASK_STORE = "/admin/task/store";
export const TASK_LISTING = "/admin/task/listing";
export const TASK_SHOW = "/admin/task/show";
export const TASK_UPDATE = "/admin/task/update";
export const MY_TASKS_LISTING = "/admin/task/my/listing";
export const MY_TASK_SHOW = "/admin/task/my/show";
export const UPDATE_MY_TASK = "/admin/task/my/update";
export const TASK_FORM_RESPONSES = "/admin/task-form/responses";
export const GET_GUEST_USERS = "/admin/task-form/guest-users";



export const TASK_ENDORSEMENT = '/admin/task/endorsement';
export const TASK_ENDORSEMENT_REQUEST = '/admin/task/endorsement/request';

export const CREATE_TASK = '/admin/company/task/create';
export const UPDATE_TASK = '/admin/company/task/update';

export const PACKAGE_STORE = "/admin/package/store";
export const PACKAGE_LISTING = "/admin/package/listing";
export const PACKAGE_SHOW = "/admin/package/show";
export const PACKAGE_UPDATE = "/admin/package/update";
export const PACKAGE_DISTROY = "/admin/package/distroy";
export const PACKAGES = "/user/packages";
export const PACKAGES_VIEW = "/admin/package/view";
export const PACKAGE_FORM_ASSIGN = '/admin/package/form/assign';
export const PACKAGE_FORM_TEMPLATE_OPTIONS = '/admin/package/form/template-options';
export const PACKAGE_DETAIL_LIST = '/admin/package/detail/list';
export const GET_PACKAGE_FORM = '/admin/package/forms';
export const PACKAGE_FORMS_LIST = '/admin/package/forms/list';
export const PACKAGE_FORM_DELETE = '/admin/package/form/delete'
export const GET_PACKAGES = '/admin/get/packages'
export const PACKAGE_COMPANIES = '/admin/package/companies'
export const PACKAGE_COMPANY_CHANGE = '/admin/package/company/change'


export const TICKET_STORE = "/admin/ticket/store";
export const TICKET_LISTING = "/admin/ticket/listing";

export const COMPANY_STORE = "/user/company/store";
export const COMPANY_CHECK = "/user/company/check";
export const BUSINESS_CATEGORY = "/admin/company/busniess/category/update";
export const CASH_PAYMENT_INVOICE = '/admin/cash/payment/invoice';

export const INVOICE_LISTING = "/admin/invoice/listing";
export const INVOICE_SHOW = "/admin/invoice/show";
export const COMPANY_LIST = "/admin/invoice/companies";

export const INVOICE_STORE = "/admin/invoice/store";
export const INVOICE_DESTROY = "/admin/invoice/destroy";
export const INVOICE_COPY = "/admin/invoice/copy";
export const INVOICE_PDF = "/admin/invoice-layout/pdf";
// export const INVOICE_PAYMENT_EDIT = '/admin/invoice/edit';
export const COMPANY_INVOICE_LIST = "/admin/invoice/list/company";
export const INVOICE_PACKAGE_LIST = "/admin/invoice/package/list";
export const COMPANY_NAME = "/admin/invoice/company/name";
export const SINGLE_INVOICE_SHOW = "/admin/invoice/edit";
export const INVOICE_UPDATE = "/admin/invoice/update";
export const CUSTOMER_INVOICE_STORE = "/admin/customer/invoice/store";
export const CUSTOMER_INVOICE_LISTING = "/admin/customer/invoice/listing";
export const CUSTOMER_INVOICE_SHOW = "/admin/customer/invoice/get";
export const CUSTOMER_INVOICE_UPDATE = "/admin/customer/invoice/update";
export const CUSTOMER_INVOICE_LIST = "/admin/customer/invoice/list";
export const CUSTOMER_NAME = "/admin/customer/invoice/name";
export const CUSTOMER_INVOICE_VIEW = "/admin/customer/invoice/show";
export const CUSTOMER_INVOICE_DESTROY = "/admin/customer/invoice/destroy";
export const CUSTOMER_INVOICE_PDF = "/admin/customer/invoice/pdf";

export const PERSONAL_INVOICE_LIST = "/admin/personal/invoice/list";
export const PERSONAL_INVOICE_SHOW = "/admin/personal/invoice/show";

// export const COMPANY_LIST = "/admin/invoice/companies";

// export const INVOICE_STORE = "/admin/invoice/store";
// export const INVOICE_PAYMENT_EDIT = "/admin/invoice/edit";
// export const COMPANY_INVOICE_LIST = "/admin/invoice/list/company";
// export const INVOICE_PACKAGE_LIST = "/admin/invoice/package/list";
export const ADMIN_USER_INVITATION = "/admin/invite-user";
export const ADMIN_COMPANY_STORE = "/admin/company/store";

export const USER_INVITATION = "/user/invite-user";

export const USER_OTP_INVITATION = "/user/invite-otp-user";

export const CALENDER_TASK = "/admin/task/my/calendar";

export const CATEGORIES = "/admin/category/categories";
export const CATEGORY_LISTING = "/admin/category/listing";
export const CATEGORY_SHOW = "/admin/category/show";
export const GET_CATEGORIES = "/user/category/get/categories";
export const GET_CATEGORY = "/user/category/get";
export const CATEGORY_STORE = "/admin/category/store";
export const CATEGORY_UPDATE = "/admin/category/update";

export const CERTIFICATE_VIEW_REQUESTS = "/admin/certificate/view/requests";
export const CERTIFICATE_VIEW = "/admin/certificate/view";

export const COMPANY_GET_DETAILS = "/admin/company/get/details";
export const COMPANY_JOBS = "/admin/company/jobs";
export const COMPANY_JOB = "/admin/company/jobs";
export const COMPANY_JOB_GET = "/admin/company/job/get";
export const COMPANY_JOB_CHAT = "/admin/company/job/chat";
export const COMPANY_JOB_CHAT_STORE = "/admin/company/job/chat/store";
export const JOB_FILES = "/admin/job/files";
export const JOB_CATEGORY_NAME = "/admin/company/job/category/name";

export const JOB_DUPLICATE = "/admin/company/job/duplicate";

export const FORM_BUILDER_GET = "/admin/job/bid/form";
export const FORM_PREVIEW = "/form/preview";
export const JOB_REVIEW_FORM_GET = "/admin/job/review/form";
// export const FORM_BUILDER_GET = "/admin/formbuilder/get";
export const FORM_BUILDER_POST = "/admin/formbuilder/post";
export const PACKAGE_FORM_BUILDER_POST = "/admin/packageformbuilder/post";
export const FORM_BUILDER_RESPONSE_GET = "/admin/formbuilder/response/get";
export const FORM_BUILDER_RESPONSE_POST = "/admin/formbuilder/response/post";
export const GUEST_FORM_SUBMIT = "/guest-response/submit/";
export const EDIT_FORMBUILDER_BODY = '/admin/formbuilder/get/body';

export const COMPANY_JOB_STORE = "/admin/comapny/job/store";
export const COMPANY_JOB_SHOW = "/admin/company/job/show";
export const COMPANY_JOB_UPDATE = "/admin/company/job/update";
export const COMPANY_JOB_EDIT = "/admin/company/job/edit";

export const COMPANY_JOB_SITE_STORE = "/admin/company/job/site/store";
export const COMPANY_JOB_BID = "admin/company/job/bid";

export const COMPANY_PROFILE_DETAIL = "/admin/company/profile/detail";
export const COMPANY_JOB_SITE_SHOW = "/admin/company/job/site/show";
export const COMPANY_JOB_SITE_SHOW_LIST = "/admin/company/job/site/show/list";
export const COMPANY_JOB_USERS_WITH_TASK = "/admin/company/job/site/show/userswithtask";
export const COMPANY_JOB_SITE_EDIT = "/admin/company/job/site/edit";
export const COMPANY_JOB_SITE_UPDATE = "/admin/company/job/site/update";

export const SITE_DOCUMENT_STORE = "/admin/job/site/document/store";
export const GET_SITE_ATTACH_DOCUMENT = "/admin/job/site/document/get";

//Site Document Endorse
export const SITE_DOCUMENT_ENDORSE = "/admin/job/site/document/endorse";
export const SITE_DOCUMENT_ENDORSE_PROGRESS = "/admin/job/site/document/endorse/progress";
export const SITE_DOCUMENT_ENDORSE_DATE_UPDATE = "/admin/job/site/document/endorse/date/update";





export const COMPANY_JOB_SITE_TASK_SHOW = "/admin/company/job/site/task/show";
export const COMPANY_JOB_SITE_TASK_UPDATE = "/admin/company/job/site/task/update";
export const COMPANY_JOB_SITE_TASK_ADD = "/admin/company/job/site/task/add";
// delete file
export const DELETE_UPLOADED_FILE = "/admin/uploaded/files/delete";
export const DELETE_GALLERY_IMAGE = "/admin/gallery/image/delete";

export const MEMBERSHIP = "/admin/membership/list";
export const MEMBERSHIP_BUYERS = "/admin/membership/buyers/list";

export const MEMBER_SEARCH_SELECT_COMPANY_NAME = "/admin/membership/company/name/list";
export const SEARCH_SELECT_COMPANY_NAME = "/admin/company/name/list";
export const MEMBER_SEARCH_SELECT_BUYERS_COMPANY_NAME = "/admin/membership/buyers/company/name/list";

export const CUSTOMER_LIST = "/admin/customer/list";
export const CUSTOMER_ROLE = "admin/customer/role";

// export const CUSTOMER_STORE = '/admin/customer/store';
// export const CUSTOMER_DESTROY = '/admin/customer/distroy';
// export const CUSTOMER_SHOW = '/admin/customer/show';
// export const CUSTOMER_UPDATE = '/admin/customer/update';
// export const CUSTOMER_SEARCH_SELECT = '/admin/customer/getname';
// export const CUSTOMERS_LIST = '/admin/customer/getcustomers';

export const STORE_COMMENTS = "/admin/comment/store";
export const GET_COMMENTS = "/admin/comment/get";

export const CUSTOMER_STORE = "/admin/customer/store";
export const CUSTOMER_DESTROY = "/admin/customer/destroy";
export const CUSTOMER_SHOW = "/admin/customer/show";
export const CUSTOMER_UPDATE = "/admin/customer/update";
export const CUSTOMER_SEARCH_SELECT = "/admin/customer/getname";
export const CUSTOMERS_LIST = "/admin/customer/getcustomers";

// formBuilder
export const FORMS_GET = "/admin/forms";
export const FORM_GET_EDIT = "/admin/form/edit";
export const FORMS_POST = "/admin/forms/store";
export const NEW_RESPONSE_REVISION = "/admin/new-response-revision";

export const FORMS_GET_PARENT = "/admin/forms/parent";
export const DOCUMENT_SEARCH_SELECT = "/admin/forms/result";
export const FORMS_DELETE = "/admin/forms/delete";
export const FORMS_UPDATE = "/admin/form/update";

export const FORM_BODIES = "/admin/document/form/bodies";
export const FORM_BODIES_COUNT = "/admin/document/form/bodies/count";
export const DOCUEMNT_FORMS_CHILD_LIST = "/admin/document/form/child-list/";



export const JOB_BID_LISTING = "/admin/job/bid/listing";
export const JOB_BID_ACCEPT = "/admin/job/bid/accept";
export const JOB_CHECK_ACCEPTED_SUPPLIER = "/admin/job/check/accepted/supplier";
export const INPROGRESS_JOBS = "/admin/job/inprogress";
export const JOB_SEARCH = "/admin/job/search";
export const JOB_BID_SEND = "/admin/job/bid/send";
export const JOB_NOTES = "/admin/job/notes";
export const JOB_OWNER = "/admin/job/owner";

export const ADMIN_CERTIFICATE = "/admin/compliance/certificates";
export const BUYER_CERTIFICATE_STORE = "/admin/buyer/certificate/store";
export const BUYER_CERTIFICATE_REQUESTS = "/admin/buyer/certificate/requests";
export const BUYER_CERTIFICATE_FORMS = "/admin/buyer/certificate/forms";
export const BUYER_CERTIFICATE_FORM_ASSIGN =
  "/admin/buyer/certificate/form/assign";
export const BUYER_CERTIFICATE_FORM_RESPONSES =
  "/admin/buyer/certificate/form/results";
export const BUYER_CERTIFICATE_APPLIED = "/admin/buyer/certificate/applied";
export const BUYER_CERTIFICATE_APPLIED_GET = "/admin/buyer/certificate/applied";
// export const BUYER_APPLIED_CERTIFICATE_FORMS = "/admin/buyer/certificate/forms";

//Certificate Issue
export const CERTIFICATE_ISSUE = "/admin/certificate/issue";

//Certificate Reject
export const CERTIFICATE_REJECT = '/admin/certificate/reject';

//Company Certificates
export const COMPANY_CERTIFICATE_LIST = '/admin/company/certificate/list';

//Certificate Form Audit Request
export const CERTIFICATE_FORM_AUDIT_REQUEST = '/admin/certificate/form/audit/request'; 

export const INTERNAL_USERS = "admin/internal/users/";
export const SHORTLIST_SUPPLIERS = "admin/shortlist/suppliers";
export const ASSIGN_USER = "admin/job/assign";
export const GET_ASSIGNED_USERS = "admin/job/assign/user";

export const DROPDOWN = "admin/job/dropdown";
export const DROPDOWN_LIST = "admin/dropdown/list";
export const ADD_DROPDOWN_VALUE = "admin/job/dropdown/add";
export const EDIT_DROPDOWN_VALUE = "admin/dropdown/edit";
export const DELETE_DROPDOWN_VALUE = "admin/dropdown/delete";

export const JOB_FORM_ASSIGN = "admin/job/form/assign";
export const FORM_BODY = "admin/form/bodies";
export const BID_RESPONSE = "admin/bid/form/response";

export const FORM_STATUS_STORE = "admin/form/status/store";
export const FORM_ACCEPT = "admin/form/accept";
export const FORM_REJECT = "admin/form/reject";
export const FORM_IMAGE_POST = "admin/formbuilder/image/post";

export const COMPANY_ASSIGN_JOBS = "admin/company/assign/jobs";

export const SITE_USER_ASSIGNED = 'admin/site/user/assigned';

export const GET_SITE_USER_ASSIGNED_LIST = 'admin/site/user/assigned/list';

export const DELETE_SITE_ASSIGNED_USER = 'admin/site/user/delete-site-assigned-user';

export const GET_COMPANY_DETAILS = 'user/registration/getCompanyDetail';


export const SHORT_LIST_USER = '/admin/shortlist/users';
export const SHORTLIST_FORM_ASSIGN = '/admin/shortlist/formassign';
export const SHORTLISTED_SUPPLIERS = '/admin/shortlisted/suppliers';
export const ALL_SUPPLIERS_LIST = '/admin/suppliers/list';
export const SUPPLIER_SHORTLIST = '/admin/supplier/shortlist';
export const SUPPLIER_SHORTLIST_TASK_STORE = '/admin/shortlist/task/store';
export const SHORTLIST_SUPPLIER_APPROVED = "admin/shortlist/suppliers/approved";

//My Document
export const MYDOCUMENT_LIST = '/admin/mydocument/list';
export const MYDOCUMENT_STORE = '/admin/mydocument/store';
export const MYDOCUMENT_SHOW = '/admin/mydocument/show';
export const MYDOCUMENT_UPDATE = '/admin/mydocument/update';
export const MYDOCUMENT_DELETE = '/admin/mydocument/delete';
export const MY_DOCUMENT_INFO = '/admin/mydocument/info';
export const UPLOADED_DOCUMENT_DELETE = '/admin/uploaded/document/delete';
export const PUBLIC_DOCUMENTS = '/admin/public/document';
export const GET_ATTACH_MY_RECORD_DOCUMENT = '/admin/attach/mydocument/get';

export const DOCUMENT_WATCH_LIST = '/admin/document/watch/list';
export const ADD_IS_WATCH_LIST = '/admin/document/watch/list/add';
export const DOCUMENT_EXPIRY_MAIL = '/admin/document/expiry/mail';
export const DOCUMENT_CATEGORIES = '/admin/document/categories';
export const DOCUMENT_SUB_CATEGORIES = '/admin/document/sub-categories';
export const DOCUMENT_EXTRA_FIELDS = '/admin/document/extra/fiels';

//Certificate
export const CERTIFICATE_CATEGORY_LIST = '/admin/certificate/categories/list';
export const CERTIFICATE_CATEGORY_STORE = '/admin/certificate/category/store';
export const CERTIFICATE_CATEGORY_SHOW = '/admin/certificate/category/show';
export const CERTIFICATE_CATEGORY_UPDATE = '/admin/certificate/category/update';
export const CERTIFICATE_CATEGORY_DELETE = '/admin/certificate/category/delete';

export const CERTIFICATE_CATEGORY_GET = '/admin/certificate/category/get';
export const CERTIFICATE_LIST = '/admin/certificates';
export const CERTIFICATE_COURSE_OPTIONS = '/admin/certificate/course/options';
export const CERTIFICATE_STORE = '/admin/certificate/store';
export const CERTIFICATE_SHOW = '/admin/certificate/show';
export const CERTIFICATE_UPDATE = '/admin/certificate/update';
export const CERTIFICATE_DELETE = '/admin/certificate/delete';
export const BUYER_CERTIFICATE_APPLY = '/admin/user/certificate/apply';

//Stages
export const STAGES_LIST = '/admin/stage/list';
export const STAGES_STORE = '/admin/stage/store';
export const STAGE_SHOW = '/admin/stage/show';
export const STAGE_UPDATE = '/admin/stage/update';
export const STAGE_DELETE = '/admin/stage/delete';
// export const FILTERSTAGESBYCOMPANY = '/admin/company/filter/stages'

//Form Input Comment
export const FORM_INPUT_COMMENT_LIST = '/admin/form/input/comment/list';
export const FORM_INPUT_COMMENT_STORE = '/admin/form/input/comment/store';
export const FORM_INPUT_COMMENT_DELETE ='/admin/form/input/comment/delete';
export const FORM_INPUT_COMMENT_UPDATE = '/admin/form/input/comment/update';

//Company Profile
export const COMPANY_PROFILE_VIEW = '/admin/company/profile/view/';

//Document Gallery 
export const DOCUMENT_GALLERY = '/admin/mydocument/gallery';

//Document Fields
export const DOCUMENT_CATEGORY = '/admin/document/category/list';
export const DOCUMENT_EXTRA_FIELDS_STORE = '/admin/document/extra/fields/store';
export const DOCUMENT_CATEGORY_STORE = '/admin/document/category/store';
export const DOCUMENT_CATEGORY_SHOW = '/admin/document/category/show';
export const DOCUMENT_CATEGORY_UPDATE = '/admin/document/category/update';
export const DOCUMENT_CATEGORY_DELETE = '/admin/document/category/delete';
export const DOCUMENT_EXTRA_FIELDS_GET = '/admin/document/fields/get';
export const DOCUMENT_FIELD_DELETE = '/admin/document/field/delete';


//Questionnaire
export const QUESTIONNAIRE_FORM_LIST = '/admin/questionnaire/forms/';
export const SUBMITED_QUESTIONNAIRES = '/admin/submited/questionnaires';
export const COMPLETED_TASKS = '/admin/completed/tasks';

//Service
export const SERVICE_LIST = '/admin/service/list';
export const SERVICE_STORE = '/admin/service/store';
export const SERVICE_SHOW = '/admin/service/show';
export const SERVICE_UPDATE = '/admin/service/update';
export const SERVICE_DELETE = '/admin/service/delete';

//Company Invoice Status
export const COMPANY_INVOICE_SATUS = '/admin/company/invoice/status';

//Audit Request
export const TASK_AUDIT = '/admin/task/audit';

//Attach Questionnaire Form
export const ATTACH_QUESTIONNAIRE_FORMS  = '/admin/attcah/questionnaire/forms';

//Task Attach Questionnaire Form
export const TASK_ATTACH_QUESTIONNAIRE  = '/admin/task/attcah/questionnaire';
export const GET_TASK_ATTACH_QUESTIONNAIRE  = '/admin/task/attcah/questionnaire/get';
export const SHOW_TASK_ATTACH_QUESTIONNAIRE  = '/admin/task/attcah/questionnaire/show';

//Public Form List
export const SELECT_PUBLIC_FORM  = '/admin/select/public/forms';
export const SELECTED_FORM_STORE  = '/admin/selected/form/store';

//Form Body Delete

export const DELETE_FORM_BODY = '/admin/form/body/delete';

//Form Body Style Update
export const BODY_STYLE_UPDATE = '/admin/form/body/style/update';

//My Document Form
export const MY_DOCUMENT_FORMS = '/admin/forms/list';

//Users For Chat
export const INTERNAL_USERS_CHAT = "/admin/internal/users/for/chat";
export const EXTERNAL_USERS_CHAT = "/admin/external/users/for/chat";

//My Site
export const MY_SITES = "admin/job/mysite/list";
export const SITE_INFORMATION = "admin/job/mysite/information";
export const SITE_INFORMATION_TASK = "admin/job/mysite/information/tasklist";

export const SITE_LOGS = "site/logs";
export const SITE_LOGS_LIST = "site/logs/list";
export const SITE_LOGS_DATA = "site/logs";

//Company Info Update
export const COMPANY_INO_UPDATE = "admin/company/info/update";

//All buyers
export const ALL_BUYERS = "admin/allbuyers/list";
export const ALL_BUYERS_DROPDOWN_LIST = "admin/allbuyers/dropdown/list";

//Update Form Revision Self
export const UPDATE_FORM_REVISION_SELF = "admin/formrevision/self/update";

//Last Invoice
export const LAST_INVOICE = "admin/company/last/invoice/get";

//Marked Job
export const MARKED_JOB = "admin/company/job/marked";

//Bid Form View
export const BID_FORM_VIEW = "admin/job/bid/form/view";

//Package Include
export const PACKAGE_INCLUDE_LIST = "admin/package/include/list";
export const INCLUDE_LIST = "admin/include/list";
export const INCLUDE_STORE = "admin/include/store";
export const INCLUDE_EDIT = "admin/include/edit";
export const INCLUDE_UPDATE = "admin/include/update";
export const INCLUDE_DELETE = "admin/include/delete";

// DOCUMENT IMPORT TO MYLIBRARY
export const DOCUMENT_IMPORT_TO_MYLIBRARY = "admin/document/import/mylibrary";
export const CHECK_BEFORE_IMPORT = "admin/check/before/import/";
export const GET_IMPORT_FORM_BODY = "admin/import/form-body/get";

//GET LOGIN COMPANY LOGO
export const GET_LOGIN_COMPANY_LOGO = "admin/company/logo";

//GET FORM ENDORSEMENT SIGNATURE PROGRESS
export const FORM_ENDORSEMENT_PROGRESS = "admin/form/endorsement/progress";

//FORM CHANGES LIST
export const FORM_CHANGES_AUTOLOAD = "admin/form/changes/autoload";
export const FORM_CHANGES_LIST = "admin/form/changes/list";
export const FORM_CHANGE_LOG = "admin/form/change/log";

// savedResponsesList
export const SAVED_RESPONSES_LIST = "admin/saved-responses-list";
export const DOCUMENT_CONTROL_REGISTER = "document-control-register/list";

//Share Response Mail
export const SHARE_RESPONSE_MAIL = "admin/share/response/mail";

//Share Response View
export const SHARE_RESPONSE_VIEW = "admin/share/response/view";

// Response Category
export const RESPONSE_CATEGORY_STORE = "admin/document/response/category/store";
export const RESPONSE_CATEGORY_FILTER_LIST = "admin/document/response/category/filter/list";
export const SAVE_RESPONSE_CATEGORY_IMPORT = "admin/save/response/category/import";

//From Theme Store
export const FORM_THEME_GET = "admin/document/form/theme/get";
export const FORM_THEME_STORE = "admin/document/form/theme/store";
export const DEFAULT_FORM_THEME_SET = "admin/document/default/form/theme/set";
export const ADD_TO_SCREENING_DOCUMENTS = "document/screening-documents";

//FILTER COMPANY USERS
export const FILTER_COMPANY_USERS = "admin/company/users";

//TASK REPORT
export const TASK_USER_LIST = "admin/task/user/list";
export const TASK_FORM_LIST = "admin/task/form/list";
export const TASK_REPORT_LIST = "admin/task/report/list";
export const TASK_REPORT_STORE = "admin/task/report/store";
export const TASK_REPORT_GENERATE = "admin/task/report/generate";
export const TASK_REPORT_DETAL = "admin/task/report/detail/list";
export const TASK_REPORT_DELETE = "task/report/delete";

export const APPLY_CERTIFICATE_INFO = "admin/new-certificate/request";

//FORM PROGRESS
export const FORM_PROGRESS = "admin/form/progress";

//Get Package Task
export const GET_PACKAGE_TASK = "admin/package/task/view";

// Lock Response
export const LOCK_FORM_BUILDER_RESPONSE_POST = "/admin/lock/formbuilder/response/post";

//Workspaces
export const WORKSPACE_LIST = '/admin/workspace/list';
// export const WORKSPACE_JOB_LIST = '/admin/workspace/job/list/';
export const WORKSPACE_COMPANY_LIST = '/admin/workspace/company/list/';
export const WORKSPACE_COMPANIES = '/admin/workspace/companies';
export const ALL_WORKSPACE = '/admin/all/workspaces';

export const WORKSPACE_STORE = '/admin/workspace/store';
export const WORKSPACE_EDIT = '/admin/workspace/edit/';
export const WORKSPACE_UPDATE = '/admin/workspace/update';
export const WORKSPACE_DELETE = '/admin/workspace/delete/';

export const GET_COMPANIES = '/admin/companies/list';

export const JOB_STAGES = '/admin/job/stages';

export const JOB_TASK_LISTING = '/admin/job/task/list';

export const GET_JOB_SITES = '/admin/job/sites/list';


// Business Detail

  // Contact
  export const COMPANY_CONTACT_LIST = '/admin/company/contact/list';
  export const COMPANY_CONTACT_STORE = '/admin/company/contact/store';
  export const COMPANY_CONTACT_EDIT = '/admin/company/contact/edit';
  export const COMPANY_CONTACT_UPDATE = '/admin/company/contact/update';

  // Office
  export const COMPANY_OFFICE_LIST = '/admin/company/office/list';
  export const COMPANY_OFFICE_STORE = '/admin/company/office/store';
  export const COMPANY_OFFICE_EDIT = '/admin/company/office/edit';
  export const COMPANY_OFFICE_UPDATE = '/admin/company/office/update';
  export const OFFICE_BRANCHES_GET = '/admin/company/office/branches/get/';

  // HeadCount
  export const COMPANY_HEADCOUNT_LIST = '/admin/company/headcount/list';
  export const COMPANY_HEADCOUNT_STORE = '/admin/company/headcount/store';
  export const COMPANY_HEADCOUNT_EDIT = '/admin/company/headcount/edit';
  export const COMPANY_HEADCOUNT_UPDATE = '/admin/company/headcount/update';

  // HeadCount
  export const COMPANY_INSURANCE_LIST = '/admin/company/insurance/list';
  export const COMPANY_INSURANCE_STORE = '/admin/company/insurance/store';
  export const COMPANY_INSURANCE_EDIT = '/admin/company/insurance/edit';
  export const COMPANY_INSURANCE_UPDATE = '/admin/company/insurance/update';
  
  // Turnover
  export const COMPANY_TURNOVER_LIST = '/admin/company/turnover/list';
  export const COMPANY_TURNOVER_STORE = '/admin/company/turnover/store';
  export const COMPANY_TURNOVER_EDIT = '/admin/company/turnover/edit';
  export const COMPANY_TURNOVER_UPDATE = '/admin/company/turnover/update';
  // Accreditation
  export const COMPANY_ACCREDITATION_LIST = '/admin/company/accreditation/list';
  export const COMPANY_ACCREDITATION_STORE = '/admin/company/accreditation/store';
  export const COMPANY_ACCREDITATION_EDIT = '/admin/company/accreditation/edit';
  export const COMPANY_ACCREDITATION_UPDATE = '/admin/company/accreditation/update';

  // Trade Association Details
  export const COMPANY_TRADE_ASSOCIATION_LIST = '/admin/company/association-details/list';
  export const COMPANY_TRADE_ASSOCIATION_STORE = '/admin/company/association-details/store';
  export const COMPANY_TRADE_ASSOCIATION_EDIT = '/admin/company/association-details/edit';
  export const COMPANY_TRADE_ASSOCIATION_UPDATE = '/admin/company/association-details/update';

  // Trade Refrence Details
  export const COMPANY_TRADE_REFRENCE_LIST = '/admin/company/refrence-details/list';
  export const COMPANY_TRADE_REFRENCE_STORE = '/admin/company/refrence-details/store';
  export const COMPANY_TRADE_REFRENCE_EDIT = '/admin/company/refrence-details/edit';
  export const COMPANY_TRADE_REFRENCE_UPDATE = '/admin/company/refrence-details/update';

  // Safety Incidents
  export const COMPANY_SAFETY_INCIDENT_LIST = '/admin/company/safety-incidents/list';
  export const COMPANY_SAFETY_INCIDENT_STORE = '/admin/company/safety-incidents/store';
  export const COMPANY_SAFETY_INCIDENT_EDIT = '/admin/company/safety-incidents/edit';
  export const COMPANY_SAFETY_INCIDENT_UPDATE = '/admin/company/safety-incidents/update';

  // Staff Training Details
  export const COMPANY_STAFF_TRAINING_LIST = '/admin/company/staff-training-detail/list';
  export const COMPANY_STAFF_TRAINING_STORE = '/admin/company/staff-training-detail/store';
  export const COMPANY_STAFF_TRAINING_EDIT = '/admin/company/staff-training-detail/edit';
  export const COMPANY_STAFF_TRAINING_UPDATE = '/admin/company/staff-training-detail/update';

  export const FORM_BUILDER_IMAGE_UPLOAD = '/admin/formbuilder/image-upload';

  export const USER_TRAINING_LIST = '/user/training/list/';
  export const ASSIGN_TRAINING = '/user/assign/training';
  export const TRAINING_REQUEST = '/user/training/request';
  export const TRAINING_REPORT = '/user/training/report';

  export const CHECK_PUBLIC_FORM_PASSWORD = '/user/check/public/form/password';

//GET ALL TRAINING TASKS FORMS
export const TRAINING_REQUEST_TASTS_FORMS = '/user/training/request/tasks/forms';



